import { useAppSelector } from "@/hooks";
import useRoutes from "@/hooks/useRoutes";
import { Menu } from "@/types";
import { getThumbnailImage } from "@/utils/media";
import { ArrowRight02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, Card, CardActions, CardContent, CardMedia, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

const MenuCard = ({ id, image, title, description, flow }: Menu) => {
  const navigate = useNavigate();
  const [_, generatePath] = useRoutes();
  const { organizationAlias } = useParams<{ organizationAlias: string }>();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);

  const goToMenu = () => {
    const url = organizationAlias ? "organizations.menu.read" : "menu.read";
    const path = generatePath(url, { menuId: id }, false);
    const qs = new URLSearchParams(window.location.search);

    if (qs.has("flow")) {
      qs.delete("flow");
    }

    if (flow) {
      qs.set("flow", flow.toString());
    }

    navigate(path + "?" + qs.toString());
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
      }}
    >
      <ButtonBase sx={{ width: "100%" }} onClick={goToMenu} component="div">
        <Stack direction="row" padding={1} spacing={2} flex={1}>
          <CardMedia
            component="img"
            image={getThumbnailImage({ file: image, organizationId })}
            sx={{
              width: "100px",
              height: "100px",
              borderRadius: 2,
            }}
          />
          <CardContent sx={{ width: "100%", textAlign: "left", padding: "8px 0" }}>
            {title ? <Typography fontSize={"20px"}>{title}</Typography> : null}
            {description ? (
              <Typography variant="body1" color="text.secondary">
                {description}
              </Typography>
            ) : null}
          </CardContent>
          <CardActions disableSpacing>
            <IconButton color="primary">
              <HugeiconsIcon icon={ArrowRight02Icon} />
            </IconButton>
          </CardActions>
        </Stack>
      </ButtonBase>
    </Card>
  );
};

export default MenuCard;
